import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's999g-s999m01',
    templateUrl: './s999g-s999m01.component.html'
})
export class S999gS999m01Component extends Overlay {
  url:any = {'value':''};

  ngOnInit(): void {
    var currentURL = window.location.href;
    const url = new URL(currentURL);
    const hostnameParts = url.hostname.split('.');
    let appName = hostnameParts[0].trim();
    appName = appName.replace('s1online','gsonline');
    hostnameParts[0] = appName;
    const newHostname = hostnameParts.join('.');
    let newURL = `${url.protocol}//${newHostname}/GS-Online-web`;
    window.location.href = newURL.trim();
  }
}
